import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { MovuRobotics_ModuleContextService } from './MovuRobotics.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class MovuRobotics_home_ComponentContextService {
  private readonly moduleContext: MovuRobotics_ModuleContextService;

  constructor(moduleContext: MovuRobotics_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'home',
      type: ComponentType.form
    }
  }
}